import { AttestationResponse, CommonsSummary, LocalSession } from "../types";

const configuredBase = (import.meta.env.VITE_API_BASE as string | undefined)?.replace(/\/$/, "");

export function apiBase() {
  return configuredBase || "";
}

async function jsonFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${apiBase()}${path}`, {
    ...init,
    headers: {
      "content-type": "application/json",
      ...(init?.headers || {})
    }
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || `Request failed: ${response.status}`);
  }
  return response.json() as Promise<T>;
}

export async function requestAttestation(deviceHash: string, turnstileToken: string) {
  return jsonFetch<AttestationResponse>("/api/attest", {
    method: "POST",
    body: JSON.stringify({ deviceHash, turnstileToken, consentVersion: "afterglow-atlas-consent-v1" })
  });
}

export async function submitSession(session: LocalSession, attest: string) {
  return jsonFetch<{ ok: true; commons: CommonsSummary }>("/api/session", {
    method: "POST",
    headers: { authorization: `Bearer ${attest}` },
    body: JSON.stringify(session)
  });
}

export async function fetchCommons(roomId = "commons") {
  return jsonFetch<CommonsSummary>(`/api/commons?room=${encodeURIComponent(roomId)}`);
}

export function roomWebSocketUrl(roomId: string, deviceHash: string, attest: string) {
  const base = apiBase() || window.location.origin;
  const url = new URL(base);
  url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
  url.pathname = `/api/room/${encodeURIComponent(roomId)}/ws`;
  url.searchParams.set("device", deviceHash);
  url.searchParams.set("attest", attest);
  return url.toString();
}
